export default __webpack_public_path__ + "static/media/avatar_koala5.12bbcac5.mp3";